import { create } from 'zustand';

export type ConversationStatusFilter = 'ALL' | 'UNREAD' | 'WAITING' | 'AI_HANDLING' | 'HUMAN_ASSIGNED' | 'CLOSED';
export type ConversationSortOrder = 'NEWEST_ACTIVITY' | 'OLDEST_WAITING';

export interface ConversationFilterState {
  selectedStoreId: string | null;
  statusFilter: ConversationStatusFilter;
  searchKeyword: string;
  sortOrder: ConversationSortOrder;
  activeConversationId: string | null;
  isCustomerDrawerOpen: boolean;
  customerFilterId: string | null;
  customerFilterName: string | null;
  setSelectedStoreId: (storeId: string | null) => void;
  setStatusFilter: (status: ConversationStatusFilter) => void;
  setSearchKeyword: (keyword: string) => void;
  setSortOrder: (sort: ConversationSortOrder) => void;
  setActiveConversationId: (id: string | null) => void;
  setCustomerDrawerOpen: (open: boolean) => void;
  setCustomerFilter: (id: string | null, name: string | null) => void;
  resetFilters: () => void;
}

export const useConversationStore = create<ConversationFilterState>((set) => ({
  selectedStoreId: null,
  statusFilter: 'ALL',
  searchKeyword: '',
  sortOrder: 'NEWEST_ACTIVITY',
  activeConversationId: null,
  isCustomerDrawerOpen: false,
  customerFilterId: null,
  customerFilterName: null,
  setSelectedStoreId: (selectedStoreId) => set({ selectedStoreId }),
  setStatusFilter: (statusFilter) => set({ statusFilter }),
  setSearchKeyword: (searchKeyword) => set({ searchKeyword }),
  setSortOrder: (sortOrder) => set({ sortOrder }),
  setActiveConversationId: (activeConversationId) => set({ activeConversationId }),
  setCustomerDrawerOpen: (isCustomerDrawerOpen) => set({ isCustomerDrawerOpen }),
  setCustomerFilter: (customerFilterId, customerFilterName) => set({ customerFilterId, customerFilterName }),
  resetFilters: () =>
    set({
      selectedStoreId: null,
      statusFilter: 'ALL',
      searchKeyword: '',
      sortOrder: 'NEWEST_ACTIVITY',
      customerFilterId: null,
      customerFilterName: null,
    }),
}));

export const conversationStore = useConversationStore;
